import React from 'react'
import Color from '../../../components/Field.Color'

import Card from './Card'
import Group from './Group'
import Label from './Group.Label'
import Item from './Group.Item'

function Component(
    {
        fieldLayout,
        disabled,

        select,
        onChange,
    }
)
{
    return (
        <Card title="Floating Button" >
            <Group>
                <Item>
                    <Label>Normal</Label>
                    <Group group>
                        <Item>
                            <Color 
                                disabled={disabled}
                                layout={fieldLayout}
                                label="พื้นหลัง"
                                name="upward.normal.bgColor"
                                alpha={true}
                                value={select('upward.normal.bgColor')}
                                onChange={onChange}
                            />
                            
                            <Color 
                                disabled={disabled}
                                layout={fieldLayout}
                                label="ตัวอักษร"
                                name="upward.normal.color"
                                alpha={true}
                                value={select('upward.normal.color')}
                                onChange={onChange}
                            />
                        </Item>
                    </Group>
                </Item>
                <Item>
                    <Label>Hover</Label>
                    <Group group>
                        <Item>
                            <Color 
                                disabled={disabled}
                                layout={fieldLayout}
                                label="พื้นหลัง"
                                name="upward.hover.bgColor"
                                alpha={true}
                                value={select('upward.hover.bgColor')}
                                onChange={onChange}
                            />
                            
                            <Color 
                                disabled={disabled}
                                layout={fieldLayout}
                                label="ตัวอักษร"
                                name="upward.hover.color"
                                alpha={true}
                                value={select('upward.hover.color')}
                                onChange={onChange}
                            />
                        </Item>
                    </Group>
                </Item>
            </Group>
        </Card>
    )
}

export default Component